module.exports = __webpack_public_path__ + "img/discount-circle.84ef0fcc.svg";